"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * myAssign
 * @param {object} obj object where you desire to assing something (it does not matter is empty or not)
 * @param {string} keyPathDotNotation path inside object whete you want to place it like: info.data already splited by .
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const myAssign = (sourceObj, targetObj) => {
    const res = Object.assign(sourceObj, targetObj);
    return res;
};
exports.default = myAssign;
//# sourceMappingURL=index.js.map